<audio #audioPlayer></audio>

<div class="container mt-5">





  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <div class="card shadow-lg">
        <div class="card-header bg-primary text-white text-center">
          <h3>{{ organization.name }}</h3>
        </div>
        <div class="card-body">

          <h6 class="card-subtitle mb-2 text-body-secondary">SMART APP Environments</h6>
          <hr>

          <!-- Environment Tabs -->
          <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="activeTab">

            @for (env of organization.smartAppEnvironments; track $index) {
            <li [ngbNavItem]="env.id">
              <button class="bg-primary" ngbNavLink>{{env.name}}</button>
              <ng-template ngbNavContent>

                <h4 class="mt-3 text-end">{{ env.name }}</h4>

                <form #envForm="ngForm">
                  <!-- SMART Phone Configs -->
                  <h5 class="mt-4">SMART Phone Configuration</h5>
                  <div class="card shadow-sm mb-4">
                    <div class="card-body">
                      <div class="mb-3">
                        <label class="form-label">Welcome Messages by Language</label>
                        <div class="mt-2">
                          <div *ngIf="environmentForms[env.id].smartPhoneWelcomeMessages.length === 0"
                            class="text-muted mb-2">
                            No welcome messages added yet.
                          </div>
                          <div *ngFor="let msg of environmentForms[env.id].smartPhoneWelcomeMessages; let i = index"
                            class="input-group mb-2">
                            <select class="form-select" [(ngModel)]="msg.language"
                              name="smartPhoneLang_{{ env.id }}_{{ i }}" required>
                              <option value="" disabled>Select Language</option>
                              <option value="en">English</option>
                              <option value="cy">Welsh</option>
                              <option value="gd">Scottish Gaelic</option>
                            </select>
                            <textarea class="form-control" [(ngModel)]="msg.message"
                              name="smartPhoneMsg_{{ env.id }}_{{ i }}" rows="2" placeholder="Enter welcome message"
                              required></textarea>
                            <button type="button" class="btn btn-outline-danger"
                              (click)="removeWelcomeMessage(environmentForms[env.id].smartPhoneWelcomeMessages, i)">
                              <i class="bi bi-trash"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary ms-2" (click)="playText(msg.message)">
                              Play
                            </button>
                          </div>
                          <button type="button" class="btn btn-link text-primary ms-2"
                            (click)="addWelcomeMessage(environmentForms[env.id].smartPhoneWelcomeMessages)">
                            + Add Welcome Message
                          </button>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label class="form-label">First Prompts by Language</label>
                        <div class="mt-2">
                          <div *ngIf="environmentForms[env.id].smartPhoneFirstPrompts.length === 0"
                            class="text-muted mb-2">
                            No first prompts added yet.
                          </div>
                          <div *ngFor="let msg of environmentForms[env.id].smartPhoneFirstPrompts; let i = index"
                            class="input-group mb-2">
                            <select class="form-select" [(ngModel)]="msg.language"
                              name="smartPhoneFirstPromptLang_{{ env.id }}_{{ i }}" required>
                              <option value="" disabled>Select Language</option>
                              <option value="en">English</option>
                              <option value="cy">Welsh</option>
                              <option value="gd">Scottish Gaelic</option>
                            </select>
                            <textarea class="form-control" [(ngModel)]="msg.message"
                              name="smartPhoneFirstPromptMsg_{{ env.id }}_{{ i }}" rows="2"
                              placeholder="Enter first prompt" required></textarea>
                            <button type="button" class="btn btn-outline-danger"
                              (click)="removeWelcomeMessage(environmentForms[env.id].smartPhoneFirstPrompts, i)">
                              <i class="bi bi-trash"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary ms-2" (click)="playText(msg.message)">
                              Play
                            </button>
                          </div>
                          <button type="button" class="btn btn-link text-primary ms-2"
                            (click)="addWelcomeMessage(environmentForms[env.id].smartPhoneFirstPrompts)">
                            + Add First Prompt
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SMART Chat Configs -->
                  <h5 class="mt-4">SMART Chat Configuration</h5>
                  <div class="card shadow-sm mb-4">
                    <div class="card-body">
                      <div class="mb-3">
                        <label class="form-label">Welcome Messages by Language</label>
                        <div class="mt-2">
                          <div *ngIf="environmentForms[env.id].smartChatWelcomeMessages.length === 0"
                            class="text-muted mb-2">
                            No welcome messages added yet.
                          </div>
                          <div *ngFor="let msg of environmentForms[env.id].smartChatWelcomeMessages; let i = index"
                            class="input-group mb-2">
                            <select class="form-select" [(ngModel)]="msg.language"
                              name="smartChatLang_{{ env.id }}_{{ i }}" required>
                              <option value="" disabled>Select Language</option>
                              <option value="en">English</option>
                              <option value="cy">Welsh</option>
                              <option value="gd">Scottish Gaelic</option>
                            </select>
                            <textarea class="form-control" [(ngModel)]="msg.message"
                              name="smartChatMsg_{{ env.id }}_{{ i }}" rows="2" placeholder="Enter welcome message"
                              required></textarea>
                            <button type="button" class="btn btn-outline-danger"
                              (click)="removeWelcomeMessage(environmentForms[env.id].smartChatWelcomeMessages, i)">
                              <i class="bi bi-trash"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary ms-2" (click)="playText(msg.message)">
                              Play
                            </button>
                          </div>
                          <button type="button" class="btn btn-link text-primary ms-2"
                            (click)="addWelcomeMessage(environmentForms[env.id].smartChatWelcomeMessages)">
                            + Add Welcome Message
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Save Button -->
                  <div class="d-flex justify-content-center mt-4">
                    <button type="button" class="btn btn-primary" (click)="saveEnvironment(env.id, envForm)"
                      [disabled]="envForm.invalid">
                      Save Messages
                    </button>
                  </div>

                  <!-- Data Export Section -->
                  <h5 class="mt-4">Apply Data to {{ env.name }}</h5>
                  <div class="card shadow-sm mb-4">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 mb-3">
                          <label for="datasetType_{{ env.id }}" class="form-label">Dataset Type</label>
                          <select class="form-select" id="datasetType_{{ env.id }}"
                            [(ngModel)]="environmentForms[env.id].selectedDatasetType" name="datasetType_{{ env.id }}">
                            <option *ngFor="let type of datasetTypes" [value]="type">{{ type }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="notes_{{ env.id }}" class="form-label">Notes (Optional)</label>
                        <textarea class="form-control" id="notes_{{ env.id }}"
                          [(ngModel)]="environmentForms[env.id].exportNotes" name="notes_{{ env.id }}" rows="3"
                          placeholder="Enter notes for this export"></textarea>
                      </div>
                      <button type="button" class="btn btn-primary" (click)="promoteData(env.id)">Export Data</button>
                    </div>
                  </div>
                </form>


              </ng-template>
            </li>
            }

          </ul>
          <fieldset readOnlyIfNoGroupPermissionDirective>

          <div [ngbNavOutlet]="nav" class="mt-2"></div>

          <div *ngIf="!organization.smartAppEnvironments?.length" class="text-muted mt-3">
            No external environments configured.
          </div>
          </fieldset>
          <!-- Action Buttons -->
          <div class="d-flex justify-content-center mt-4">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
          </div>



        </div>
      </div>


      
          <!-- Export History Section -->
          <h5 class="mt-4">Export History</h5>
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Dataset Type</th>
                    <th>Environment</th>
                    <th>Timestamp</th>
                    <th>Exported By</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let history of exportHistory">
                    <td>{{ history.datasetType }}</td>
                    <td>{{ history.smartAppEnvironmentName }}</td>
                    <td>{{ history.exportTimestamp | date:'medium' }}</td>
                    <td>{{ history.exportedBy }}</td>
                    <td>{{ history.notes || '-' }}</td>
                  </tr>
                  <tr *ngIf="exportHistory.length === 0">
                    <td colspan="6" class="text-center">No export history available.</td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between align-items-center">
                <button class="btn btn-outline-primary" [disabled]="!hasPreviousPage"
                  (click)="changePage(currentPage - 1)">Previous</button>
                <span>Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total records)</span>
                <button class="btn btn-outline-primary" [disabled]="!hasNextPage"
                  (click)="changePage(currentPage + 1)">Next</button>
              </div>
            </div>
          </div>

    </div>
  </div>
</div>